import getProp from '@f/get-prop'

export const isRequestingAccountsBySourceId = (state, sourceId) =>
  getProp(`accountsBySourceId.${sourceId}.isRequesting`, state) || false

export const didFailToRequestAccountsBySourceId = (state, sourceId) =>
  getProp(`accountsBySourceId.${sourceId}.didRequestFail`, state) || false

export const getAccountsBySourceId = (state, sourceId) =>
  getProp(`accountsBySourceId.${sourceId}.data`, state) || []

export const didRequestAccountsBySourceId = (state, sourceId) =>
  getProp(`accountsBySourceId.${sourceId}.didRequest`, state) || false



// WEBPACK FOOTER //
// ./selectors/accounts-by-sourceid.js